
import { Modal, Button, Card, Row, Col } from "react-bootstrap";

const soporteContactos = [
  {
    nombre: "Candy Manrique",
    cargo: "Soporte de Aplicaciones",
    telefono: "+573152266785",
    
  },
  {
    nombre: "Vladimir Anaya",
    cargo: "Administrador de Sistemas",
    telefono: "+573163711428",
  },
];

export default function SoporteModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Soporte Técnico</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="g-4">
          {soporteContactos.map((c, idx) => (
            <Col md={6} key={idx}>
              <Card
                style={{
                  borderRadius: "15px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  padding: "1rem",
                  height: "100%",
                  transition: "transform 0.2s",
                }}
                className="h-100"
              >
                <Card.Body>
                  <Card.Title
                    className="mb-2"
                    style={{ fontSize: "1.25rem", fontWeight: "600" }}
                  >
                    {c.nombre}
                  </Card.Title>
                  <Card.Subtitle className="mb-3 text-muted">
                    {c.cargo}
                  </Card.Subtitle>
                  <Card.Text style={{ lineHeight: "1.6", fontSize: "0.95rem" }}>
                    📞 <strong>Teléfono:</strong> {c.telefono}
                  </Card.Text>

                  {/* Botón WhatsApp con degradado */}
                  <Button
                    className="mt-2 w-100"
                    style={{
                      background: "linear-gradient(90deg, #4e73df, #1cc88a)",
                      border: "none",
                      fontWeight: "600",
                    }}
                    onClick={() =>
                      window.open(
                        `https://wa.me/${c.telefono.replace(/\D/g, "")}`,
                        "_blank"
                      )
                    }
                  >
                    💬 WhatsApp
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
